module.exports = __webpack_public_path__ + "media/images/games/k2gender/black-977653a88ab89cdc253d32646dda426a.png";